module.exports = __webpack_public_path__ + "img/security-2-image.009ed237.jpg";